import { useState } from 'react';
import { WinModal } from '../ui-kit/Feedback';

export function PreviewWinPage({ amount = 1500, title = 'BINGO!' }: { amount?: number, title?: string }) {
    const [isOpen, setIsOpen] = useState(true);

    if (!isOpen) {
        return (
            <div className="min-h-screen bg-black flex items-center justify-center text-white">
                <button
                    onClick={() => setIsOpen(true)}
                    className="px-6 py-3 bg-primary rounded-xl font-bold"
                >
                    Replay Animation
                </button>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#1A0B2E]">
            <WinModal
                isOpen={isOpen}
                amount={amount}
                title={title}
                currency="BingoChips"
                onClose={() => setIsOpen(false)}
                onClaim={() => setIsOpen(false)}
            />
        </div>
    );
}
